import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(unauthenticated)/forgot-password/forgotPassword.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(unauthenticated)/forgot-password/passBackButton.tsx");
